export function isValidEmail(eStr) {
  var mailExReg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return mailExReg.test(eStr);
}
